<template>
  <div id="technicalSupportQueue">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Technical Support Queue</div>
          <!-- Button for Clear Cache -->
          <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
        </div>
        <div class="container-fluid">
          <div class="from-group">
            <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong id="errorMsg" class="field-error"></strong>
            </div>
          </div>
          <div class="admin-page-content user-feedback-list">
            <data-table-filter-config :moduleName="'technicalSupportQueue'" :removeLineButtonVisibility="true"
                                      :addFilterButtonVisibility="true" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'technicalSupportQueue'" :position="'top'">
              </custom-pagination>
              <vue-good-table
                ref="technicalSupportQueue"
                mode="remote"
                title="Technical Support Queue"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                :select-options="{
                                        enabled: false,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                :search-options="{
                                        enabled: false,
                                    }">
                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field === 'action'">
                      <router-link
                        title="Edit Technical Request"
                        v-if="canUpdateTechnicalRequest"
                        class="fp-edit"
                        :to="{ name: 'TechnicalSupportRequestUpdate', params: { id: props.row.id } }"
                      ></router-link>
                      <svg v-if="isAdminUser && props.row.ticket_status == 'New'"
                           style="margin-top: -5px;stroke: var(--color-orange-rizon);"
                           stroke-width="2" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="17" height="17"
                           viewBox="0 0 50 50">
                        <path
                          d="M 25 0 C 22.800781 0 21 1.800781 21 4 C 21 4.515625 21.101563 5.015625 21.28125 5.46875 C 15.65625 6.929688 12 11.816406 12 18 C 12 25.832031 10.078125 29.398438 8.25 31.40625 C 7.335938 32.410156 6.433594 33.019531 5.65625 33.59375 C 5.265625 33.878906 4.910156 34.164063 4.59375 34.53125 C 4.277344 34.898438 4 35.421875 4 36 C 4 37.375 4.84375 38.542969 6.03125 39.3125 C 7.21875 40.082031 8.777344 40.578125 10.65625 40.96875 C 13.09375 41.472656 16.101563 41.738281 19.40625 41.875 C 19.15625 42.539063 19 43.253906 19 44 C 19 47.300781 21.699219 50 25 50 C 28.300781 50 31 47.300781 31 44 C 31 43.25 30.847656 42.535156 30.59375 41.875 C 33.898438 41.738281 36.90625 41.472656 39.34375 40.96875 C 41.222656 40.578125 42.78125 40.082031 43.96875 39.3125 C 45.15625 38.542969 46 37.375 46 36 C 46 35.421875 45.722656 34.898438 45.40625 34.53125 C 45.089844 34.164063 44.734375 33.878906 44.34375 33.59375 C 43.566406 33.019531 42.664063 32.410156 41.75 31.40625 C 39.921875 29.398438 38 25.832031 38 18 C 38 11.820313 34.335938 6.9375 28.71875 5.46875 C 28.898438 5.015625 29 4.515625 29 4 C 29 1.800781 27.199219 0 25 0 Z M 25 2 C 26.117188 2 27 2.882813 27 4 C 27 5.117188 26.117188 6 25 6 C 23.882813 6 23 5.117188 23 4 C 23 2.882813 23.882813 2 25 2 Z M 27.34375 7.1875 C 32.675781 8.136719 36 12.257813 36 18 C 36 26.167969 38.078125 30.363281 40.25 32.75 C 41.335938 33.941406 42.433594 34.6875 43.15625 35.21875 C 43.515625 35.484375 43.785156 35.707031 43.90625 35.84375 C 44.027344 35.980469 44 35.96875 44 36 C 44 36.625 43.710938 37.082031 42.875 37.625 C 42.039063 38.167969 40.679688 38.671875 38.9375 39.03125 C 35.453125 39.753906 30.492188 40 25 40 C 19.507813 40 14.546875 39.753906 11.0625 39.03125 C 9.320313 38.671875 7.960938 38.167969 7.125 37.625 C 6.289063 37.082031 6 36.625 6 36 C 6 35.96875 5.972656 35.980469 6.09375 35.84375 C 6.214844 35.707031 6.484375 35.484375 6.84375 35.21875 C 7.566406 34.6875 8.664063 33.941406 9.75 32.75 C 11.921875 30.363281 14 26.167969 14 18 C 14 12.261719 17.328125 8.171875 22.65625 7.21875 C 23.320313 7.707031 24.121094 8 25 8 C 25.886719 8 26.679688 7.683594 27.34375 7.1875 Z M 21.5625 41.9375 C 22.683594 41.960938 23.824219 42 25 42 C 26.175781 42 27.316406 41.960938 28.4375 41.9375 C 28.792969 42.539063 29 43.25 29 44 C 29 46.222656 27.222656 48 25 48 C 22.777344 48 21 46.222656 21 44 C 21 43.242188 21.199219 42.539063 21.5625 41.9375 Z"></path>
                      </svg>
                    </div>

                    <div v-else-if="props.column.field === 'attachment'">
                      <ol>
                        <li v-for="attachment in props.row.attachment">
                          <a
                            v-if="attachment.file_path !== ''"
                            @click="goToGetDocumentPath($event, attachment)"
                            title="View Document"
                            href="#"
                            style="font-size: 15px;"
                          >
                            <i class="fp-text-document">{{ attachment.file_desc }}</i>
                          </a>
                        </li>
                      </ol>
                    </div>
                    <div v-else-if="props.column.field === 'pwa_doc_link'">
                      <a
                        v-if="props.row.pwa_file_path !== '' && props.row.pwa_file_path !== null"
                        @click="goToGetDocumentPath($event, props.row.pwa_file_path, 'pwa')"
                        title="View Document"
                        href="#"
                        style="font-size: 15px;">
                        <i class="fp-text-document"></i>
                      </a>
                      <span v-else>-</span>
                    </div>
                    <div v-else-if="props.column.field === 'status'">
                      {{ titleCase(props.row.status) }}
                    </div>

                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>
              </vue-good-table>
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import LoadingContent from "@/components/LoadingContent.vue";
import EventBus from "../event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import {dataTableMixins} from "../../mixins/dataTableMixins";

Vue.component("loading-content", LoadingContent);
Vue.use(VueGoodTable);


export default {
  name: "TechnicalSupportQueue",
  components: {
    customPagination: () => import('@/components/layout/CustomPagination'),
    dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
    clearCacheData: () => import('@/components/ClearCacheData'),
    appFooter: () => import('@/components/Footer'),
  },
  mixins: [commonMixins, dataTableMixins, contractMixins],
  metaInfo() {
    return {
      title: "Technical Support Queue | " + process.env.COPYRIGHT_NAME
    }
  },

  data: () => ({
    permissions: [],
    cantAccessPage: '',
    userColumns: [],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
      },
      {
        label: 'Creation Date',
        field: 'creation_date',
        fpFieldType: "date",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Support Ticket #',
        field: 'ticket_number',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Support Ticket Number", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Status',
        field: 'ticket_status',
        fpFieldType: "option",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Status", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
          filterDropdownItems: ['Closed', 'Draft', 'In Process', 'New'],

        }
      },
      {
        label: 'VIN',
        field: 'vin',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Vin", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Vehicle System',
        field: 'vehicle_system',
        fpFieldType: "option",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Vehicle System", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
          filterDropdownItems: [
            'Brakes',
            'Cab - Interior & Exterior',
            'Front Axle',
            'HV - Battery',
            'HV - Charging',
            'HV - Control Unit',
            'HV - E-Axle',
            'HV - E-PTO',
            'HV - Inverter',
            'HV - Wiring',
            'HVAC',
            'Low Voltage System',
            'LV - Battery',
            'Suspension',
            'Thermal System'
          ],

        }
      },
      {
        label: 'Dealer Code',
        field: 'dealer_code',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Dealer Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Dealer RO #',
        field: 'dealer_ro_number',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Dealer RO", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Odometer (mi)',
        field: 'odometer',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Odometer", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'PWA #',
        field: 'pwa_number',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "PWA Number", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Last Modified (Date)',
        field: 'updated_at',
        fpFieldType: "date",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
        // sortable:false
      },
      {
        label: 'Time Since Last Update (days/hours)',
        field: 'since_last_update',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Time Since Last Update (days/hours)", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Attachment(s) Link',
        field: 'attachment',
        fpFieldType: "text",
        hidden: false,
        filterable: false,
        sortable: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Attachment", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Assigned to',
        field: 'assigned_to',
        fpFieldType: "text",
        hidden: false,
        filterable: false,
        sortable: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Assigned To", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Time To Respond (D-H-M)',
        field: 'time_to_respond',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Time To Respond", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    loading: false,
    pageKey: "_technical_support_queue_",
    errorMsg: "",
    canUpdateTechnicalRequest: false,
    isAdminUser: false,
    rizonColumns: [
      {
        label: 'TAR #',
        field: 'tar_number',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Tar #", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'PWA Description',
        field: 'pwa_desc',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "PWA Description", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'PWA Document Link',
        field: 'pwa_doc_link',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "PWA Document Link", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'PWA Create Date',
        field: 'pwa_create_date',
        fpFieldType: "date",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "PWA Create Date", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'PWA Created By',
        field: 'pwa_created_by',
        fpFieldType: "text",
        hidden: false,
        filterable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "PWA Created By", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ]
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name === 'ev_list_technical_support') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name === 'ev_update_technical_support') {
            self.canUpdateTechnicalRequest = true;
          }
          if (permissions[i].name === 'ev_load_all_dealer_dropdown') {
            self.isAdminUser = true;
          }
          if (permissions[i].name === 'ev_can_access_internal_technical_support') {
            self.rizonColumns.forEach(column => {
              self.columns.push(column);
            });
          }
        }
      }
    },
  },
  mounted: function () {
    var self = this;
    self.getPermissions();
  },
  methods: {
    cancelAll: function () {
      this.$refs.userFeedbackList.unselectAllInternal();
    },

    selectionChanged(param) {
      if (param.selectedRows.length === 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
    },
    loadList() {
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
      };
      $.ajax({
        url: process.env.ROOT_API + "/technical-support/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'technical-support-queue');
        }
      });
    },
    goToGetDocumentPath(event, row, column = '') {
      event.preventDefault();
      var self = this;
      if (column == 'pwa') {
        var path = row;
      } else {
        var path = row.file_path;
      }
      var flag = '';
      var id = 0;
      if (row.id > 0) {
        id = row.id;
      }
      self.getDocumentPath(id, path, flag);
    },

  }
};
</script>
<style scoped>
.data-table table {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/technicalSupport/TechnicalSupportQueue.vue